import React from 'react';
import BookingTrustStrip from './BookingTrustStrip';

const STEPS = [
	{
		num: '1',
		title: 'Reserve your place',
		text: 'Pay the deposit shown at checkout to hold your seat — usually a small percentage of the trip price.',
	},
	{
		num: '2',
		title: 'We gather travellers',
		text: 'Others join the same departure for your journey and month — one slot, no duplicates.',
	},
	{
		num: '3',
		title: 'VisitAllNepal confirms',
		text: 'Once minimum group size is reached, we confirm the departure and you pay the remaining balance.',
	},
	{
		num: '4',
		title: 'Operator assigned',
		text: 'We pick the best verified local operator internally — never shown on this site.',
	},
	{
		num: '5',
		title: 'You travel',
		text: 'Receive final details from VisitAllNepal and go.',
	},
];

function GroupDepartureHowItWorks({ compact = false }) {
	if (compact) {
		return (
			<div className="booking-aside">
				<h2>How group departures work</h2>
				<p className="booking-aside__lead">
					Every departure belongs to VisitAllNepal — not an operator listing. You reserve with us;
					we handle logistics and operator assignment.
				</p>
				<ol className="booking-aside__steps booking-aside__steps--numbered">
					{STEPS.map((step) => (
						<li key={step.num}>
							<strong>{step.title}</strong>
							<span>{step.text}</span>
						</li>
					))}
				</ol>
				<BookingTrustStrip light />
			</div>
		);
	}

	return (
		<section className="gd-how-it-works" aria-labelledby="gd-how-title">
			<h2 id="gd-how-title" className="gd-how-it-works__title">How Group Departures work</h2>
			<p className="gd-how-it-works__lead">
				Every departure belongs to VisitAllNepal — not an operator listing. You reserve with us; we handle logistics and operator assignment.
			</p>
			<ol className="gd-how-it-works__steps">
				{STEPS.map((step) => (
					<li key={step.num} className="gd-how-it-works__step">
						<span className="gd-how-it-works__num" aria-hidden="true">{step.num}</span>
						<div>
							<h3 className="gd-how-it-works__step-title">{step.title}</h3>
							<p className="gd-how-it-works__step-text">{step.text}</p>
						</div>
					</li>
				))}
			</ol>
			<BookingTrustStrip light />
		</section>
	);
}

export default GroupDepartureHowItWorks;
